import { render, staticRenderFns } from "./PricingTierCreate.vue?vue&type=template&id=ebd2c9fc&scoped=true"
import script from "./PricingTierCreate.vue?vue&type=script&lang=js"
export * from "./PricingTierCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd2c9fc",
  null
  
)

export default component.exports